export enum FormName {
  ANALYTICS_EXPORT_DIALOG = 'AnalyticsExportDialog',
}

export default FormName;
